<template>
    <div class="parentlevel">
        <div class="downouter" :style="{ width: outerwidth }">
            <div class="downcore" :style="{ width: corewidth + '%' }"><span style="position: absolute; left: 3vw">1h</span></div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      outerwidth: "100%;",
      corewidth: 100
    }
  },
    props:{
      time:{
          type:Number,
          default(){ return 0 }
      }
    },
  computed: {
    // 滚动区高度
    // (业务需求：手机屏幕高度减去头部标题和底部tabbar的高度，当然这2个高度也是可以动态获取的)
    // scrollerHeight: function () {
    //   return (window.innerHeight - 46 - 50) + 'px'
    // }
  },
  mounted () {
    setInterval(this.parentlevel, this.time)
  },
  methods: {
    parentlevel () {
      this.corewidth--
    }
  }
}
</script>

<style scoped>
.parentlevel {
    width: 4vw;
    height: 1.3vh;
    margin-left: 1vw;
    border-radius: 15px;
}
.downouter {
    width: 100%;
    height: 100%;
    border-radius: 15px;
    background-color: #31659e;
}
.downcore {
    width: 100%;
    height: 100%;
    font-size: 0.8vw;
    line-height: 9px;
    border-radius: 15px;
    background-color: #ed4846;
}
</style>
